<p-dialog-container class="popup_top_index">
    <p-dialog-header title="{{ 'longRequestCenter.header' | translate }}"></p-dialog-header>

    <div class="p-dialog-content">
        <ng-container *ngIf="rows$ | async as rows">
            <ng-container *ngIf="rows?.length; else noContent">
                <common-grid
                    #grid="CommonGrid"
                    [gridOptions]="gridOptions"
                    [defaultColDef]="defaultColDef"
                    [columnDefs]="columns"
                    [rowData]="rows"
                    [refreshGridAfterRowUpdate]="true"
                    [frameworkComponents]="frameworkComponents"
                    [getRowNodeId]="rowNodeId"
                    [enableRefresh]="false"
                    [attr.automation-id]="'request-status-grid'"
                >
                </common-grid>
            </ng-container>

            <ng-template #noContent>
                <empty-state class="p-headline-5" visualSource="request_status_empty_state" text="">
                    <p class="p-headline-5">{{ 'longRequestCenter.noRequestFound' | translate }}</p>
                </empty-state>
            </ng-template>
        </ng-container>
    </div>

    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
